import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f66d5136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = { class: "container my-1 mb-3" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "MotionScan")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/salusmo_logo-32x32.png')
          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createTextVNode("Home")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/session" }, {
      default: _withCtx(() => [
        _createTextVNode("Session")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/token" }, {
      default: _withCtx(() => [
        _createTextVNode("Token")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/metrics" }, {
      default: _withCtx(() => [
        _createTextVNode("Metrics")
      ]),
      _: 1
    }),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
    }, "Logout")
  ]))
}